export * from './bing-maps-view';
export * from './bing-maps-view-with-zoom-button';
